export interface ActionItem {
  label: string;
  onSelect: () => void | Promise<void>;
  destructive?: boolean;
}

export function showActionSheet(title: string, items: ActionItem[]): Promise<void> {
  return new Promise((resolve) => {
    const root = document.createElement('div');
    root.className = 'action-sheet';
    root.innerHTML = `
      <div class="action-sheet__backdrop"></div>
      <div class="action-sheet__panel" role="dialog" aria-label="${title}">
        <div class="action-sheet__title">${title}</div>
        ${items.map((item, i) => `
          <button class="action-sheet__item ${item.destructive ? 'is-destructive' : ''}" data-i="${i}">
            ${item.label}
          </button>
        `).join('')}
        <button class="action-sheet__cancel">キャンセル</button>
      </div>
    `;
    document.body.appendChild(root);
    requestAnimationFrame(() => root.classList.add('is-open'));

    const close = () => {
      root.classList.remove('is-open');
      setTimeout(() => { root.remove(); resolve(); }, 200);
    };
    root.querySelector('.action-sheet__backdrop')!.addEventListener('click', close);
    root.querySelector('.action-sheet__cancel')!.addEventListener('click', close);
    root.querySelectorAll<HTMLButtonElement>('.action-sheet__item').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const i = Number(btn.dataset.i);
        await items[i]!.onSelect();
        close();
      });
    });
  });
}
